import { render } from "./GenerateTags.vue?vue&type=template&id=22a9cdf2&ts=true"
import script from "./GenerateTags.vue?vue&type=script&lang=ts"
export * from "./GenerateTags.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__